export * from './pop-up.component';
export * from './pop-up.module';
